var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "menu_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F0E5B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3.75 12h16.5M3.75 6h16.5M3.75 18h16.5"
})));
export default SvgMenu;